
import { useContext, useEffect, useState, useRef } from 'react'
import axios from 'axios'
import Modal from 'react-modal'
import { useForm } from 'react-hook-form'

import { projectContext, loadingContext, urlValue, unfolder, closeModalVw, openModalVw, useTranslate } from '../../lib'
// import AsideBar from './AsideBar'

import './chat-resume.scss'

export default function CallChatResume(props) {
    const { data, callinfo } = props
    const [loading, setLoading] = useState(false)
    const [call, setCall] = useState(callinfo)
    const [assement, setAssement] = useState(data) 
    const [avatarLeft, setAvatarLeft] = useState(null)
    const [avatarRight, setAvatarRight] = useState(null)
    const { t } = useTranslate();

    const avatarLeftUrlRef = useRef(null)
    const avatarRightUrlRef = useRef(null)
    const project_data = JSON.parse(localStorage.getItem('report_project_selected'))
    const backgroundImage = project_data?.backgroundImage || ''
    const agentBubbleImage = project_data?.agentBubbleImage || ''
    const clientBubbleImage = project_data?.clientBubbleImage || ''
    const custom_chat = project_data?.custom_chat || 0
    useEffect(() => {
        setAssement(data)
    }, [data])

    useEffect(() => {
        setCall(callinfo)
    }, [callinfo])

    useEffect(() => {

        const clientId = call?.bussiness_key;
        const agentId = call?.project;

        const fetchAvatar = async ({ id, folder }) => {
            if (!id) return null
            try {
                const headers = {}

                const hash = localStorage.getItem('hashUser');
                const user = hash ? unfolder(hash, 'IANestingKey') : null;

                if (user?.token) headers['access-token'] = user.token;
                if (user?.csrfToken) headers['X-CSRF-Token'] = user.csrfToken;

                headers['client-id'] = id
                headers['folder'] = folder
                headers['Cache-Control'] = 'no-cache, no-store, must-revalidate'
                headers['Pragma'] = 'no-cache'

                const res = await axios.get(`${urlValue}/studio/avatar`, { headers, responseType: 'blob' })
                if (res.status === 200 && res.data) {
                    const blob = res.data
                    const url = URL.createObjectURL(blob)
                    console.log('Fetched avatar URL:', url)
                    return url
                }
            } catch (err) {
                console.warn('Avatar could not be loaded from server', err)
                return null
            }
            return null
        }

        (async () => {

            const left = await fetchAvatar({ id: agentId, folder: 'agents' });
            const right = await fetchAvatar({ id: clientId, folder: 'clients' });

            if (avatarLeftUrlRef.current && avatarLeftUrlRef.current !== left) {
                URL.revokeObjectURL(avatarLeftUrlRef.current)
            }
            if (avatarRightUrlRef.current && avatarRightUrlRef.current !== right) {
                URL.revokeObjectURL(avatarRightUrlRef.current)
            }

            avatarLeftUrlRef.current = left
            avatarRightUrlRef.current = right

            setAvatarLeft(left)
            setAvatarRight(right)
        })()

        return () => {
            if (avatarLeftUrlRef.current) URL.revokeObjectURL(avatarLeftUrlRef.current)
            if (avatarRightUrlRef.current) URL.revokeObjectURL(avatarRightUrlRef.current)
        }

    }, [assement, call])
  
    return (

        <>
            <div class="info-call w-full" style={{ backgroundColor: 'white', paddingTop: 10 }}  >
                <div class="info-call-item header flex items-center w-full justify-center" style={{ padding: 15, backgroundColor: "white" }} >
                    <div class="agents flex items-center ">
                        <div class="img">

                            <img alt='' src="/icons/tpAgent.png" style={{ width: 150, height: 100, objectFit: 'contain', marginRight: 30 }} />

                        </div>
                        <div class="img">
                            <img src="/icons/tpClient.png" alt="" style={{ width: 180, height: 100, objectFit: 'contain' }} />
                            {/* <!--<span>TP Client</span>--> */}
                        </div>
                    </div>
                    <div class="higiliths">
                        <img alt="" src="/icons/sentiment2.png" style={{ width: 142, height: 100, objectFit: 'contain' }} />
                    </div>
                </div>
                <div class="call-resume-container" >
                    <div class="call-resume-loading">
                        <h2>{t('common.conversation')}</h2>
                    </div>
                    <div style={custom_chat !== 0 && backgroundImage ? {
                        backgroundImage: `url(${backgroundImage})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        padding: '15px 15px 7px 15px'
                    } : { paddingLeft: 20, paddingRight: 20 }}>
                        <div id="sidebar-chat" class="call-resume-indicators" >
                            {assement?.sentiment.map((item, idex) => (
                                <div class=""  >
                                    {item.user !== '' &&
                                        <div class="call-resume-text" style={custom_chat !== 0 && agentBubbleImage ? {
                                            backgroundImage: `url(${agentBubbleImage})`,
                                            backgroundSize: 'cover',
                                            backgroundRepeat: 'no-repeat',
                                            backgroundPosition: 'left',
                                            minWidth: '350px',
                                            minHeight: '100px',
                                            width: 'fit-content',
                                            height: 'fit-content',
                                            padding: '10px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            position: 'relative',
                                            maxWidth: 'fit-content',
                                            borderRadius: '30px'
                                        } : {paddingTop:15, paddingBottom:15}}>
                                            <div className='flex items-start justify-start'>
                                                <div className='flex flex-col items-start justify-start' style={{ marginLeft: 12 }}>
                                                <img class="avatar_left" src={avatarLeft || '/icons/tpAgentMini.png'} alt="" style={{ marginLeft: 12, width: 60, height: 60 }} />
                                                    <div class="text-left" style={{ color: '#575756', paddingLeft: '10px' }}>{item.time_message_agent}</div>
                                                </div>
                                                <div className='flex flex-col items-start justify-start'>
                                                    <div class="text-left">{t('reports.sentiment')}: {item.polarity}</div>
                                                    <div class="text-left" style={{ color: '#575756',width:500 }}>{item.user}</div>
                                                </div>

                                            </div>

                                        </div>
                                    }
                                    <div style={{ display: 'flex', justifyContent: 'flex-end'}} >
                                            <p class="text-bot chat-bot" style={custom_chat !== 0 && clientBubbleImage ? {
                                            backgroundImage: `url(${clientBubbleImage})`,
                                            backgroundSize: 'cover',
                                            backgroundRepeat: 'no-repeat',
                                            backgroundPosition: 'right',
                                            minWidth: '350px',
                                            minHeight: '100px',
                                            width: 'fit-content',
                                            height: 'fit-content',
                                            padding: '10px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            position: 'relative',
                                            maxWidth: 'fit-content',
                                            marginLeft: 'auto',
                                            borderRadius: '30px'
                                        } : { color: '#575756',width:500 }}>{item?.bot}
                                            <img class="avatar_right" src={avatarRight || '/icons/tpClientMini.png'} alt="" style={{ width: 60, height: 60 }} />
                                        </p>
                                    </div>
                                    <div style={{ display: 'flex', justifyContent: 'flex-end', color: '#575756', paddingRight: '20px' }}>{item.time_message_bot}</div>
                                </div>))}
                        </div>
                    </div>
                </div>
            </div>

        </>


    )
}
